/**
 * Created by anatoly on 14.11.2024
 */

const ReceivedCalendarTileComponent = cc.Node.extend({
    ctor: function () {
        this._super();

        this.createMarks();
    },

    createMarks: function () {
        const styles = cleverapps.styles.PrizeCalendarTileView;

        this.mark = new cleverapps.Spine(bundles.prizecalendar.jsons.check_json);
        this.mark.setAnimationAndIdleAfter("popup", "idle");
        this.mark.setAlignment(styles.mark);
        this.addChild(this.mark);
    }
});